// removed by extract-text-webpack-plugin
module.exports = {"testimonialContainer":"testimonialContainer__3WnhM","innerContainer":"innerContainer__319ng","testimonialHeading":"testimonialHeading__1dIi9","innerHeading":"innerHeading__1upq4","upperHeading":"upperHeading__6JOex","patchImage":"patchImage__3ZdsM","slideButtons":"slideButtons__3fHX7","active":"active__38joU","slideshowContainer":"slideshowContainer__Z259j","cardContainer":"cardContainer__19wPF","slideRight":"slideRight__1N_xO","slideLeft":"slideLeft__1xPzU"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVD/testimonials/style.css
// module id = KZ87
// module chunks = 458